import { Person } from "#clockwise/web-commons/src/ui/person-selector/types";
import * as ISchema from "@clockwise/schema";
import {
  OnboardingOrgInviteQuery,
  OnboardingOrgInviteRendererQuery,
} from "./__generated__/OnboardingInviteDialog.generated";

export const getPersonsFromEventAttendees = (
  people: Pick<ISchema.Person, "primaryEmail" | "profile">[],
) => {
  return people.map((p) => {
    const newPerson: Person = {
      email: p.primaryEmail,
      name: {
        givenName: p.profile ? p.profile.givenName : p.primaryEmail,
        familyName: p.profile ? p.profile.familyName : "",
      },
      externalImageUrl: p.profile ? p.profile.externalImageUrl : "",
      isSuggested: false,
    };
    return newPerson;
  });
};

export type PersonListPaginated = Extract<
  Extract<
    OnboardingOrgInviteQuery["node"],
    { __typename: "Org" }
  >["orgPersonListPaginatedErrorable"],
  { __typename: "OrgPersonListPaginated" }
>["searchPersons"];

export type SuggestedPersons = Extract<
  Extract<OnboardingOrgInviteRendererQuery["node"], { __typename: "Org" }>["suggestedInvites"],
  { __typename: "SuggestedOrgInviteConnection" }
>["edges"];

export type PendingPersons = Extract<
  Extract<OnboardingOrgInviteRendererQuery["node"], { __typename: "Org" }>["pendingInvites"],
  { __typename: "OrgInviteConnection" }
>["edges"];

const isInPersonsList = (email: string, personArray: SuggestedPersons | PendingPersons) =>
  personArray?.some((person) => person?.node?.targetCalendarId === email);

export const getPersonsFromSearchPersons = (
  people: PersonListPaginated,
  suggestedPersons: SuggestedPersons,
  pendingPersons: PendingPersons,
  alreadySelected: Person[],
) => {
  const suggestions: Person[] = [];
  people?.forEach((p) => {
    const person = p.person;
    const isAlreadySelected = alreadySelected.some((p) => person.primaryCalendarId === p.email);
    if (!person.userId && !isAlreadySelected) {
      const newPerson: Person = {
        email: person.primaryCalendarId,
        name: {
          givenName: person.profile ? person.profile.givenName : person.primaryCalendarId,
          familyName: person.profile ? person.profile.familyName : "",
        },
        externalImageUrl: person.profile ? person.profile.externalImageUrl : "",
        isSuggested: isInPersonsList(person.primaryCalendarId, suggestedPersons),
        isPending: isInPersonsList(person.primaryCalendarId, pendingPersons),
      };
      suggestions.push(newPerson);
    }
  });
  return suggestions;
};

export const getPersonsFromSuggestions = (
  suggestedPersons: SuggestedPersons,
  alreadySelected: Person[],
) => {
  const suggestions: Person[] = [];
  suggestedPersons?.forEach((person) => {
    const isAlreadySelected = alreadySelected.some(
      (p) => person?.node?.targetCalendarId === p.email,
    );
    if (!isAlreadySelected) {
      const personNode = person?.node;
      const profile = personNode?.targetProfile;

      if (!personNode || !profile || !personNode.targetCalendarId) {
        return;
      }
      const newPerson: Person = {
        email: personNode.targetCalendarId,
        name: {
          givenName: profile ? profile.givenName : personNode.targetCalendarId,
          familyName: profile ? profile.familyName : "",
        },
        externalImageUrl: profile ? profile.externalImageUrl : "",
        isSuggested: true,
        isPending: false,
      };
      suggestions.push(newPerson);
    }
  });
  return suggestions;
};
